import styled from 'styled-components';

const Button = ({ children, ...props }) => (
  <S.Button {...props}>{children}</S.Button>
);

const S = {
  Button: styled.button`
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primaryText};
    border: none;
    padding: 1rem 1.25rem;
    border-radius: 6px;
    text-transform: capitalize;
    letter-spacing: -0.2px;
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &:focus {
      opacity: 0.9;
    }
  `,
};

export default Button;
